import React from 'react';
import { Link } from 'react-router-dom';

import { LogoBlack } from '../../common/icons/Logos';

import ForgotPasswordForm from '../../auth/forgot-password/ForgotPasswordForm';

const ForgotPasswordPageMobile = () => {
  return (
    <div className="m-container">
      <div className="is-flex justify-content-center py-20px">
        <Link to="/">
          <LogoBlack />
        </Link>
      </div>

      <p className="auth-page-title">Password reset</p>
      <ForgotPasswordForm />

      <div className="auth-page-footer">
        <Link to="/auth" className="auth-page-link">
          Back to login
        </Link>
      </div>
    </div>
  );
};

export default ForgotPasswordPageMobile;
